<template>
  <div>
    <v-card class="ma-3" outlined>
      <v-card-text class="pa-1">
        <v-row no-gutters>
          <v-text-field v-model="c_query" class="ma-1" outlined dense hide-details clearable label="Cauta" background-color="white" prepend-inner-icon="mdi-magnify"/>
          <v-divider vertical class="ma-1"/>
          <div class="ma-1">
            <v-btn depressed color="create white--text" block height="40" @click="dialog = true">
              <v-icon left>mdi-plus</v-icon>
              Adaugă
            </v-btn>
          </div>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" width="960">
      <v-card>

        <v-toolbar class="primary white--text" flat dark>
          <v-toolbar-title>Hotel</v-toolbar-title>
          <v-spacer/>
          <v-btn icon @click="dialog=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-3">
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field v-model="name" class="ma-1" label="Nume" outlined dense hide-details/>
            </v-col>
            <v-col cols="12">
              <v-select v-model="supplier" label="Furnizor" class="ma-1" :items="suppliers" outlined dense hide-details/>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="mx-2"/>

        <v-card-actions>
          <v-btn color="primary" text @click="dialog=false">
            Anuleaza
          </v-btn>
          <v-spacer/>
          <v-btn color="primary" :disabled="loading || !name" :loading="loading" depressed @click="save()">
            Salveaza
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

  </div>

</template>


<script>

  import default_hotel from '@/defaults/default-hotel'

  import hotel_repository from '@/repositories/hotel-repository'
  import profile_repository from '@/repositories/profile-repository'
  import supplier_repository from "@/repositories/supplier-repository";

  export default {

    props: {
      query: null
    },

    data: () => ({
      name: null,
      supplier: null,
      suppliers: null,
      loading: false,
      dialog: false,
    }),

    computed: {
      c_query: {
        get() {
          return this.query;
        },
        set(val) {
          this.$emit("update:query", val);
        }
      }
    },

    async created() {
      try {
        const suppliers = await supplier_repository.getSuppliers(null, {page: 1, size: 1000});
        this.suppliers = suppliers.data.map(supplier => ({text: supplier.contact.name, value: supplier.id}));
      } catch (e) {
        await this.$store.dispatch('alert/error', e);
      }
    },

    methods: {
      save: async function () {
        try {
          this.loading = true;

          let profile = await profile_repository.getMyProfile();

          let clone_hotel = _.cloneDeep(default_hotel);
          clone_hotel.name = this.name;
          clone_hotel.org_id = profile.organization_id || 1;
          clone_hotel.supplier_id = this.supplier;

          let hotel = await hotel_repository.saveHotel(clone_hotel);
          hotel =  {
            id: hotel.id,
            name: hotel.name,
            city: hotel.static.location.address.city,
            country: hotel.static.location.address.country,
          };

          this.dialog = false;

          this.$root.$emit('selectHotel', hotel);
          await this.$store.dispatch('hotel/setHotel', hotel);
          await this.$store.dispatch('alert/success', 'Success');
          await this.$router.push(`/hotels/${hotel.id}`);

        } catch (e) {
          await this.$store.dispatch('alert/error', 'Error');
        } finally {
          this.loading = false;
        }
      }
    }

  }
</script>